import { FC } from 'react';
import classNames from 'classnames';
import BlankLink from '../BlankLink/BlankLink';

interface LinkBoxContainerProps {
  title?: string;
  items: { title: string; url: string }[];
}
const LinkBoxContainer: FC<LinkBoxContainerProps> = ({ title, items }) => {
  return (
    <>
      {items.length > 0 && (
        <div
          className={classNames(
            'flex flex-col w-full pt-[36px] laptop:pb-[61px] items-center gap-[31px] mb-[73px] laptop:mb-[121px] laptop:px-7'
          )}
        >
          <span className="gap-[16px] w-full">
            <h3 className="uppercase font-[400] text-[29px] laptop:text-[38px] font-plakat leading-[120%] tracking-[0.01em]">
              {title}
            </h3>
          </span>
          <div
            className={classNames(
              'flex self-start gap-[16px] flex-wrap w-full'
            )}
          >
            {items.map((item, index) => {
              return (
                <BlankLink key={index} href={item.url} linkText={item.title} />
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default LinkBoxContainer;
